import React from 'react'

const FreeTrialIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.118 12.882a.64.64 0 0 1 .002.905l-5.308 5.333a.64.64 0 0 1-.903.004l-2.025-2a.64.64 0 1 1 .9-.91l1.57 1.551 4.86-4.881a.64.64 0 0 1 .904-.002Z"
        fill="url(#a)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.174 3.976a3.625 3.625 0 0 0-2.608 1.053.64.64 0 0 1-.632.16 3.635 3.635 0 0 0-3.727 1.055c-.38.42-.654.925-.8 1.471a.64.64 0 0 1-.469.456 3.625 3.625 0 0 0-2.653 4.452.64.64 0 0 1-.178.629 3.625 3.625 0 0 0-.08 5.185.64.64 0 0 1 .16.631 3.635 3.635 0 0 0 1.054 3.727c.421.38.925.654 1.472.801a.64.64 0 0 1 .456.469 3.625 3.625 0 0 0 4.452 2.657.64.64 0 0 1 .628.178 3.623 3.623 0 0 0 5.185.075.64.64 0 0 1 .632-.16 3.634 3.634 0 0 0 3.727-1.054c.38-.42.654-.925.8-1.472a.64.64 0 0 1 .47-.456 3.625 3.625 0 0 0 2.657-4.452.64.64 0 0 1 .178-.628 3.625 3.625 0 0 0 .075-5.184.64.64 0 0 1-.16-.632 3.636 3.636 0 0 0-1.055-3.727 3.592 3.592 0 0 0-1.471-.801.64.64 0 0 1-.456-.469 3.623 3.623 0 0 0-4.452-2.657.64.64 0 0 1-.628-.178 3.625 3.625 0 0 0-2.577-1.13Zm-1.89-.924a4.905 4.905 0 0 1 5.13.912 4.905 4.905 0 0 1 5.561 3.319 4.915 4.915 0 0 1 3.157 5.656 4.908 4.908 0 0 1-.093 6.477 4.907 4.907 0 0 1-3.32 5.562 4.872 4.872 0 0 1-.975 1.64 4.915 4.915 0 0 1-4.68 1.516 4.905 4.905 0 0 1-6.478-.093 4.907 4.907 0 0 1-5.561-3.32 4.915 4.915 0 0 1-3.157-5.656 4.905 4.905 0 0 1 .098-6.476A4.905 4.905 0 0 1 7.28 7.028a4.915 4.915 0 0 1 5.656-3.157c.402-.344.857-.62 1.348-.819Z"
        fill="url(#b)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 7.975a8.027 8.027 0 1 0 0 16.054 8.027 8.027 0 0 0 0-16.054Zm-9.307 8.027a9.307 9.307 0 1 1 18.614 0 9.307 9.307 0 0 1-18.614 0Z"
        fill="url(#c)"
      />
      <defs>
        <radialGradient
          id="a"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-142.36 14.82 6.692) scale(15.8974 52.3051)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="b"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-38.89284 -39.06973 132.9071 -132.30535 35.987 36.282)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="c"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-27.20377 -27.32464 92.9523 -92.54115 29.979 30.186)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default FreeTrialIcon